<template>
  <div style="height: 100%">
    <div v-if="banner.mediaType && banner.mediaType == 'youtube' && banner.type == 1" class="video-b-promo-block">
      <a class="video-b-promo" href="#" target="_blank">
        <youtube :video-id="banner.src" ref="youtube" :nocookie="true" :resize="true" :player-vars="playerVars" @ready="readyPlayers" :width="resizeVideoWidth" :height="resizeVideoHeight"></youtube>
      </a>
    </div>
    <div v-else-if="banner.mediaType && banner.mediaType == 'image' && banner.type == 1" class="medium-b-promo-block"  style="width:300px">
      <a @click.prevent="clickOnBanner" href="#" target="_blank">
        <img :src="banner.src" alt="">
      </a>
    </div>
    <div v-else-if="banner.mediaType && banner.mediaType == 'image' && banner.type == 2" class="skysrapper-b-promo-block" style="width: 300px">
      <a @click.prevent="clickOnBanner" href="#" target="_blank">
        <img :src="banner.src" alt="">
      </a>
    </div>
    <div v-else-if="banner.mediaType && banner.mediaType == 'image' && banner.type == 3" class="skysrapper-b-promo-block" style="width: 300px">
      <a @click.prevent="clickOnBanner" href="#" target="_blank">
        <img :src="banner.src" alt="">
      </a>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
export default {
  name: 'advert-banner',
  props: {
    bannerType: {
      type: String,
      default () {
        return '1'
      }
    },
    rfqId: {
      type: String,
      default () {
        return ''
      }
    },
    pageType: {
      type: String,
      default () {
        return '';
      }
    },
  },
  data () {
    return {
      resizeVideoWidth: 640,
      resizeVideoHeight: 360,
      banner: {
        link: '',
        src: '',
        type: '',
        mediaType: '',
      },
      playerVars: {
        //autoplay: 1,
        loop: 1,
        modestbranding: 1,
      }
    }
  },
  computed: {
    player() {
      return this.$refs.youtube.player
    },
    computedElWidth() {
     return this.$el.clientWidth
    }
  },
  methods: {
    readyPlayers(){
      console.log('ready players')
      this.player.mute();
      this.player.setLoop(true);
      this.player.playVideo()
    },
    loadBanner () {
      Axios.get('/adv/b?type=' + this.bannerType + '&rfqId=' + this.rfqId)
          .then(response => {
            if (response.data._status && response.data.data.length >0) {
              this.banner = response.data.data[0]
              // this.banner = banners[0]
            }
          })
    },
    clickOnBanner () {
      if (this.banner.link) {
        window.open(this.banner.link, '_blank').focus()
      }
    },
  },
  mounted () {
    this.loadBanner();
    if (this.pageType === 'rfq-view') {
      this.resizeVideoWidth = document.documentElement.clientWidth - 1380
      console.log('clientWidth - ' + this.resizeVideoWidth)
    } else if (this.pageType === 'rfq-order') {
      this.resizeVideoWidth = this.computedElWidth - 20
    }
    this.resizeVideoHeight = this.resizeVideoWidth / 1.78;
  },
  components:{
  }
}
</script>

<style>
  iframe {
    position: sticky;
    top: 150px;
  }
</style>
